import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataProducts = [
  {
    Header: "Código",
    accessor: "code",
  },
  {
    Header: "Nombre",
    accessor: "name",
  },
  {
    Header: "Categoria",
    accessor: "category.name",
  },
  {
    Header: "Modelos",
    accessor: "model.description",
    maxWidth: "11rem",
  },
  {
    Header: "Moneda",
    accessor: "currency.code",
  },
  {
    Header: "Precio actual",
    accessor: "currentCost",
  },
  {
    Header: "Stock (inv.)",
    accessor: "currentStock",
  },
  {
    Header: "Unidad",
    accessor: "unit.name",
    minWidth: "5.5rem",
    maxWidth: "7rem",
    whiteSpace: "nowrap",
  },
  {
    Header: "Proveedor",
    accessor: "provider.name",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      },
    ]
  }
  
];
